module.exports = __webpack_public_path__ + "img/frame (225).2c811732.jpg";